import { classNames } from 'libs/react';
import { DealItemPanelToolBar } from './DealItemPanelToolBar';
import { Money } from 'components/Money';
import { Panel } from 'components/Panel';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { useCallback, useEffect, useMemo, useState, memo } from 'react';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { Case } from 'components/util/Case';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { DealItemPanelGroup } from './dealItemPanelGroup/DealItemPanelGroup';
import { useUser } from 'components/user/UserProvider';
import './DealItemPanel.scss';
import { useAccount } from 'components/account/AccountProvider';
import { getConfigurationLineTotal } from 'helpers/DealQuantity';
import { getPriceFromItem } from 'helpers/Pricing';
/**
 * @component DealItemPanel
 * @since 1.0.0
 */
function DealItemPanelComponent(props) {
    var _a, _b;
    const { style, deal, item } = Object.assign({ style: 'normal' }, props);
    const user = useUser();
    const { pricingParametersDisplay, updateDealField, discountRep, configurationFields } = useDealConfiguratorContext();
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const [dealItemPackagesCount, setDealItemPackagesCount] = useState(0);
    const itemSorting = useMemo(() => {
        var _a, _b, _c;
        return (_c = JSON.parse((_b = (_a = configurationFields.find((conf) => conf.fieldKey === 'ITEM_SORTING')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '{}')) === null || _c === void 0 ? void 0 : _c.value;
    }, [configurationFields]);
    const hideSKU = useMemo(() => {
        var _a, _b, _c;
        return (_c = JSON.parse((_b = (_a = configurationFields.find((conf) => conf.fieldKey === 'HIDE_SKU')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '{}')) === null || _c === void 0 ? void 0 : _c.value;
    }, [configurationFields]);
    const { sortedNormalOptions, sortedProposedOptions } = useMemo(() => {
        let normal = [];
        let proposed = [];
        if (item.options) {
            const normalOptions = [...item.options.filter((opt) => !opt.proposed)];
            const proposedOptions = [...item.options.filter((opt) => opt.proposed)];
            if (itemSorting === 'TITLE') {
                normalOptions.sort((a, b) => {
                    var _a, _b;
                    if (((_a = a.item) === null || _a === void 0 ? void 0 : _a.title) && ((_b = b.item) === null || _b === void 0 ? void 0 : _b.title)) {
                        return a.item.title.localeCompare(b.item.title);
                    }
                    return 0;
                });
                proposedOptions.sort((a, b) => {
                    var _a, _b;
                    if (((_a = a.item) === null || _a === void 0 ? void 0 : _a.title) && ((_b = b.item) === null || _b === void 0 ? void 0 : _b.title)) {
                        return a.item.title.localeCompare(b.item.title);
                    }
                    return 0;
                });
            }
            if (itemSorting === 'SKU') {
                normalOptions.sort((a, b) => {
                    var _a, _b;
                    if (((_a = a.item) === null || _a === void 0 ? void 0 : _a.sku) && ((_b = b.item) === null || _b === void 0 ? void 0 : _b.sku)) {
                        return a.item.sku.localeCompare(b.item.sku);
                    }
                    return 0;
                });
                proposedOptions.sort((a, b) => {
                    var _a, _b;
                    if (((_a = a.item) === null || _a === void 0 ? void 0 : _a.sku) && ((_b = b.item) === null || _b === void 0 ? void 0 : _b.sku)) {
                        return a.item.sku.localeCompare(b.item.sku);
                    }
                    return 0;
                });
            }
            if (itemSorting === 'SALE_ITEM_GROUP') {
                normalOptions.sort((a, b) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                    const orderDiff = ((_c = (_b = (_a = a.item) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.order) !== null && _c !== void 0 ? _c : 0) - ((_f = (_e = (_d = b.item) === null || _d === void 0 ? void 0 : _d.group) === null || _e === void 0 ? void 0 : _e.order) !== null && _f !== void 0 ? _f : 0);
                    if (orderDiff !== 0)
                        return orderDiff;
                    return ((_j = (_h = (_g = a.item) === null || _g === void 0 ? void 0 : _g.group) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : '').localeCompare((_m = (_l = (_k = b.item) === null || _k === void 0 ? void 0 : _k.group) === null || _l === void 0 ? void 0 : _l.title) !== null && _m !== void 0 ? _m : '');
                });
                proposedOptions.sort((a, b) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                    const orderDiff = ((_c = (_b = (_a = a.item) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.order) !== null && _c !== void 0 ? _c : 0) - ((_f = (_e = (_d = b.item) === null || _d === void 0 ? void 0 : _d.group) === null || _e === void 0 ? void 0 : _e.order) !== null && _f !== void 0 ? _f : 0);
                    if (orderDiff !== 0)
                        return orderDiff;
                    return ((_j = (_h = (_g = a.item) === null || _g === void 0 ? void 0 : _g.group) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : '').localeCompare((_m = (_l = (_k = b.item) === null || _k === void 0 ? void 0 : _k.group) === null || _l === void 0 ? void 0 : _l.title) !== null && _m !== void 0 ? _m : '');
                });
            }
            if (itemSorting === 'ORDER') {
                normalOptions.sort((a, b) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); });
                proposedOptions.sort((a, b) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); });
            }
            if (itemSorting === 'OPTION_TIME') {
                const toTimeMinutes = (value) => {
                    const timePart = value.includes('T') ? value.split('T')[1] : value;
                    const [h, m] = timePart.split(':').map(Number);
                    return h * 60 + (m || 0);
                };
                const byTime = (a, b) => {
                    if (!a.startTime && !b.startTime)
                        return 0;
                    if (!a.startTime)
                        return 1;
                    if (!b.startTime)
                        return -1;
                    return toTimeMinutes(a.startTime) - toTimeMinutes(b.startTime);
                };
                normalOptions.sort(byTime);
                proposedOptions.sort(byTime);
            }
            normal = normalOptions;
            proposed = proposedOptions;
        }
        return {
            sortedNormalOptions: normal,
            sortedProposedOptions: proposed
        };
    }, [item.options, itemSorting]);
    /**
     * @function getCostPriceTotal
     * @since 1.0.0
     * @hidden
     */
    const getCostPriceTotal = useCallback((item) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let total = ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.price)
            ? ((_b = item.variant) === null || _b === void 0 ? void 0 : _b.price) - (discountRep * ((_c = item.variant) === null || _c === void 0 ? void 0 : _c.price)) / 100
            : ((_d = item.item) === null || _d === void 0 ? void 0 : _d.price)
                ? ((_e = item.item) === null || _e === void 0 ? void 0 : _e.price) - (discountRep * ((_f = item.item) === null || _f === void 0 ? void 0 : _f.price)) / 100
                : 0;
        total *= item.quantity;
        if (item.packages) {
            for (const configuration of item.packages) {
                if (!configuration.proposed) {
                    const unitCost = (configuration === null || configuration === void 0 ? void 0 : configuration.package) && (configuration === null || configuration === void 0 ? void 0 : configuration.package.price)
                        ? configuration.package.price -
                            (discountRep * configuration.package.price) / 100
                        : 0;
                    total += getConfigurationLineTotal(unitCost, (_g = configuration.quantity) !== null && _g !== void 0 ? _g : 0, (_h = configuration.package) === null || _h === void 0 ? void 0 : _h.quantityCalculation, deal);
                }
            }
        }
        if (item.options) {
            for (const configuration of item.options) {
                if (!configuration.proposed) {
                    const catalogUnit = getPriceFromItem(item.item, (_j = item.variant) !== null && _j !== void 0 ? _j : null, (_k = configuration.item) !== null && _k !== void 0 ? _k : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency);
                    const unitCost = catalogUnit - (discountRep * catalogUnit) / 100;
                    total += getConfigurationLineTotal(unitCost, (_l = configuration.quantity) !== null && _l !== void 0 ? _l : 0, (_m = configuration.item) === null || _m === void 0 ? void 0 : _m.quantityCalculation, deal);
                }
            }
        }
        return total;
    }, [deal, discountRep]);
    /**
     * @function getAmountTotal
     * @since 1.0.0
     * @hidden
     */
    const getAmountTotal = useCallback((item) => {
        var _a, _b, _c, _d, _e, _f;
        let total = item.price * item.quantity;
        if (item.packages) {
            for (const configuration of item.packages) {
                if (!configuration.proposed) {
                    total += getConfigurationLineTotal((_a = configuration.price) !== null && _a !== void 0 ? _a : 0, (_b = configuration.quantity) !== null && _b !== void 0 ? _b : 0, (_c = configuration.package) === null || _c === void 0 ? void 0 : _c.quantityCalculation, deal);
                }
            }
        }
        if (item.options) {
            for (const configuration of item.options) {
                if (!configuration.proposed) {
                    total += getConfigurationLineTotal((_d = configuration.price) !== null && _d !== void 0 ? _d : 0, (_e = configuration.quantity) !== null && _e !== void 0 ? _e : 0, (_f = configuration.item) === null || _f === void 0 ? void 0 : _f.quantityCalculation, deal);
                }
            }
        }
        return total;
    }, [deal]);
    /**
     * @function filterProposedPackagesOut
     * @since 1.0.0
     * @hidden
     */
    function filterProposedPackagesOut(item) {
        var _a;
        const filteredPackages = (_a = item.packages) === null || _a === void 0 ? void 0 : _a.filter((pack) => !pack.proposed);
        return Object.assign(Object.assign({}, item), { packages: filteredPackages });
    }
    /**
     * @function containProposedPackages
     * @since 1.0.0
     * @hidden
     */
    const containProposedPackages = (item) => {
        var _a;
        const proposedPackagesCounts = (_a = item.packages) === null || _a === void 0 ? void 0 : _a.filter((pack) => pack.proposed).length;
        return !!proposedPackagesCounts;
    };
    const amountTotal = useMemo(() => getAmountTotal(item), [getAmountTotal, item]);
    const costTotal = useMemo(() => getCostPriceTotal(item), [getCostPriceTotal, item]);
    useEffect(() => {
        var _a, _b;
        setDealItemPackagesCount((_b = (_a = item.packages) === null || _a === void 0 ? void 0 : _a.filter((pack) => !pack.proposed).length) !== null && _b !== void 0 ? _b : 0);
    }, [item]);
    const className = classNames('deal-item-panel', 'deal-item-panel--' + style, props.className);
    /**
     * @function onChangeProposedItem
     * @since 1.0.0
     * @hidden
     */
    const onChangeProposedItem = (item, active) => {
        const itemIndex = deal.items.findIndex((i) => i.id === item.id);
        const tempItems = [...deal.items];
        tempItems[itemIndex] = Object.assign(Object.assign({}, item), { proposed: active });
        updateDealField('items', tempItems, 'array');
    };
    return (React.createElement(Panel, { className: className },
        React.createElement("div", { className: "deal-item-panel-head", id: '#' + item.id },
            React.createElement(DealItemPanelToolBar, { item: item, onChangeProposedItem: onChangeProposedItem }),
            React.createElement(SaleItemViewer, { item: item.item, variant: (_a = item.variant) !== null && _a !== void 0 ? _a : undefined, proposed: item.proposed, alternativeTo: deal.items.find((i) => i.id === item.alternativeTo)
                    ? (_b = deal.items.find((i) => i.id === item.alternativeTo)) === null || _b === void 0 ? void 0 : _b.item.title
                    : null })),
        React.createElement("div", { className: "deal-item-panel-body" },
            React.createElement("div", { className: "deal-item-panel-body-section" },
                React.createElement(DealItemPanelGroup, { type: "item", item: item, discountRep: discountRep, showIncludedOptions: deal.showIncludedOptions, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, onChangeProposedItem: onChangeProposedItem, deal: deal, collapse: false })),
            item.packages && item.packages.length > 0 && (React.createElement("div", { className: "deal-item-panel-body-section" },
                React.createElement(DealItemPanelGroup, { type: "package", item: filterProposedPackagesOut(item), discountRep: discountRep, showIncludedOptions: deal.showIncludedOptions, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, deal: deal, collapse: dealItemPackagesCount > 0 ? false : true }))),
            item.options && item.options.length > 0 && (React.createElement("div", { className: "deal-item-panel-body-section" },
                React.createElement(DealItemPanelGroup, { type: "option", item: Object.assign(Object.assign({}, item), { options: sortedNormalOptions }), discountRep: discountRep, showIncludedOptions: deal.showIncludedOptions, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, deal: deal, collapse: false }))),
            React.createElement("div", { className: "deal-item-panel-body-section" },
                React.createElement("div", { className: "deal-item-panel-footer" },
                    React.createElement("div", { className: "deal-item-panel-footer-section" },
                        React.createElement(Text, { value: t('Total') })),
                    React.createElement("div", { className: "deal-item-panel-footer-section-container" },
                        React.createElement("div", { className: "deal-item-panel-footer-section" },
                            React.createElement(Money, { value: amountTotal }),
                            React.createElement(Text, { value: deal.currency.code })),
                        user.isContactUser() && dealerColumn && (React.createElement("div", { className: "deal-item-panel-footer-section" },
                            t('Your partner price'),
                            React.createElement(Money, { value: costTotal }),
                            React.createElement(Text, { value: deal.currency.code })))))),
            sortedProposedOptions.length > 0 && (React.createElement("div", { className: "deal-item-panel-body-section" },
                React.createElement(DealItemPanelGroup, { type: "optionProposed", item: Object.assign(Object.assign({}, item), { options: sortedProposedOptions }), discountRep: discountRep, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, editable: true, isDeal: true, showIncludedOptions: deal.showIncludedOptions, deal: deal, collapse: false }))),
            React.createElement(Case, { is: containProposedPackages(item) },
                React.createElement("div", { className: "deal-item-panel-body-section" }, item.packages && item.packages.length > 0 && (React.createElement(DealItemPanelGroup, { type: "packageProposed", item: item, discountRep: discountRep, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, editable: true, isDeal: true, deal: deal, collapse: false })))))));
}
export const DealItemPanel = memo(DealItemPanelComponent);
